import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png"

const ShortDescription: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);


    return (
        <div style={{marginTop:"30px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1 style={{lineHeight:"2em",textAlign:"left",padding:"0 90px"}}>
                {en ? "PROJECT SUMMARY:" : "РЕЗЮМЕ ПРОЕКТУ:" }
            </h1>
            <div style={{lineHeight:"2em",textAlign:"left",padding:"0 90px"}}>
                {en ?
                    <div>
                        <p>
                            DOMANI aims to build an educational partnership between twelve EU, Ukrainian and Mongolian institutions to
                            launch micro-credentials ecosystems in both Ukraine and Mongolia for competitive and resilient green economies.
                            To do so, DOMANI brings EU expertise to develop:
                        </p>
                        <p>
                            1) organizational, ICT, and mentorship capacities for enrollment, certification and QA in microcredential provision to
                            HEI students and LLLearners;
                        </p>
                        <p>
                            2) regulatory proposals and a policy learning to pave the way for nationwide adoption;
                        </p>
                        <p>
                            3) meaningful labor market engagements and business partnerships for uptake and financial sustainability;
                        </p>
                        <p>
                            4) a Joint Learning Platform and online training services;
                        </p>
                        <p>
                            5) capacity for academic mobility, joint experimental facilities and curriculums to ensure flexible learning pathways.
                        </p>
                        <p>
                            The partnership will create 91 ECTS worth of new and upgraded courses within 6-cross-cutting topics identified by DOMANI
                            stakeholders, responding to needs of green transformation, tackling environmental emergencies, as well as environmental
                            aspects of post-war recovery and war resilience in Ukraine. Further to this, students will be offered challenge-based
                            modules looking for solutions to specific, complex real-life issues, while engaging industry and societal actors.
                            Opportunities for Lifelong Learning and taking microcredentials will be offered to existing students through university
                            announcements and mentorship, to employees of local businesses through partnerships and to the general public through open
                            events. Supporting these, the partnership will organize a series of national and international hackathons, summer universities,
                            an international conference, and a range of capacity building events in academia. DOMANI supports EU priorities, such as the
                            EU Green Deal with its focus themes, Digital Transformation with digital connectivity and distant learning,
                            Integration of Migrants displaced by war, and Sustainable Growth and Jobs through business-oriented skill development opportunities.
                        </p>
                    </div> : <div>
                        <p>
                            DOMANI має на меті побудувати освітнє партнерство між дванадцятьма установами ЄС, України та Монголії для запуску
                            екосистем мікрокредитування в Україні та Монголії для створення конкурентоспроможної та стійкої зеленої економіки.
                            Для цього DOMANI залучає досвід ЄС для розвитку.
                        </p>
                        <p>
                            1) організаційного, ІКТ та наставницького потенціалу для зарахування, сертифікації та забезпечення якості надання
                            мікрокредитів студентам вищих навчальних закладів та особам, які навчаються на курсах післядипломної освіти;
                        </p>
                        <p>
                            2) регуляторні пропозиції та вивчення політики, щоб прокласти шлях до загальнонаціонального прийняття;
                        </p>
                        <p>
                            3) значуща взаємодія з ринком праці та бізнес-партнерство для засвоєння та фінансової стійкості;
                        </p>
                        <p>
                            4) Спільна навчальна платформа та послуги онлайн-навчання;
                        </p>
                        <p>
                            5) спроможність до академічної мобільності, спільні експериментальні об'єкти та навчальні
                            програми для забезпечення гнучких шляхів навчання.
                        </p>
                        <p>
                            У рамках партнерства буде створено нові та вдосконалені існуючі курси загальним обсягом 91 кредитів ECTS
                            у межах 6 наскрізних тем, визначених зацікавленими сторонами DOMANI, що відповідають потребам зеленої
                            трансформації, подолання надзвичайних екологічних ситуацій, а також екологічним аспектам післявоєнного
                            відновлення та стійкості до війни в Україні. Крім того, студентам будуть запропоновані модулі, що базуються
                            на пошуку рішень для конкретних, складних реальних проблем, із залученням представників промисловості та
                            громадськості. Можливості для навчання впродовж життя та отримання мікрокредитів будуть запропоновані існуючим
                            студентам через університетські оголошення та наставництво, працівникам місцевого бізнесу - через партнерства,
                            а широкій громадськості - через відкриті заходи. Підтримуючи їх, партнерство організує серію національних та
                            міжнародних хакатонів, літніх університетів, міжнародну конференцію та низку заходів з розбудови потенціалу в
                            академічних колах. DOMANI підтримує пріоритети ЄС, такі як "Зелений курс ЄС" з його основними темами, цифрову
                            трансформацію з цифровим зв'язком та дистанційним навчанням, інтеграцію мігрантів, переміщених війною, а також
                            стале зростання та робочі місця через бізнес-орієнтовані можливості для розвитку навичок.
                        </p>

                    </div>}

            </div>
        </div>
    )
}
export default ShortDescription;